import Image from "next/legacy/image";
import Carousel from "@common/components/Carousel";
import { Thumbnail } from "@modules/for-you/types";
import { useReportsCarouselControls } from "@modules/for-you/hooks";
import { useStore as useDocVaultStore } from "@modules/docvault/state";
import { Typography } from "@earned/core";

export interface PersonalizedAdviceCarouselProps {
  thumbnails: Thumbnail[];
}

const PersonalizedAdviceCarousel: React.FC<PersonalizedAdviceCarouselProps> = (
  props
) => {
  const { setCurrentThumbnailIndex, formattedThumbnailTitle } =
    useReportsCarouselControls(props.thumbnails);
  const { setPreviewFile } = useDocVaultStore();

  return (
    <div className="max-w-[880px] rounded-md border border-primary bg-white">
      <Carousel
        afterSlide={setCurrentThumbnailIndex}
        withoutControls={props.thumbnails.length === 1}
      >
        {props.thumbnails.map((thumbnail) => (
          <div
            key={thumbnail.id}
            className="xlg:max-w-[420px] mb-10 mt-5 max-w-[180px] cursor-pointer sm:max-w-[220px] md:max-w-[260px] lg:max-w-[300px]"
          >
            <div className="flex shadow-lg">
              <Image
                onClick={() => {
                  setPreviewFile(thumbnail.file);
                }}
                alt={`${thumbnail.name} pdf thumbnail`}
                src={thumbnail.imgSrc}
              />
            </div>
          </div>
        ))}
      </Carousel>
      <div className="p-4 text-center">
        <Typography variant="title-md" color="primary" weight="medium">
          Your {formattedThumbnailTitle}
          <span className="font-normal"> Report</span>
        </Typography>
      </div>
    </div>
  );
};

export default PersonalizedAdviceCarousel;
